import React, { useCallback, useEffect } from 'react';
import cn from 'classnames';

import * as interfaces from 'interfaces';
import { useClientContext, useUserContext, useFilterAndSearchContext, useApplyFilterAndSearch, useTranslationContext } from 'hooks';
import { QuestionServiceInstance, createQuestionServiceInstance } from 'services';

import { getClientOptions } from 'scripts/clients/index'

import QuestionsItem from '../QuestionsItem';

import classes from './QuestionsList.module.scss';

createQuestionServiceInstance();

export default function QuestionsList(props: {
  isMobile?: boolean;
}) {
  const { isMobile } = props;
  const { client, questions, setQuestions } = useClientContext();
  const { user, userIsSet, isSignedIn } = useUserContext();
  const { filter, search } = useFilterAndSearchContext();
  const { t } = useTranslationContext();
  const {
    setOriginalItems: setOriginalQuestions,
    mappedItems: filteredQuestions,
    updateMappedItems: updateMappedQuestions
  } = useApplyFilterAndSearch<interfaces.QuestionInterface>({ filter, search });

  const handleVoteClick = useCallback(
    (question: interfaces.QuestionInterface) => {
      QuestionServiceInstance?.voteForQuestion({ questionId: question.id, userId: user.id + '', amount: 1 }).then(
        () => {
          updateMappedQuestions(((curr: interfaces.QuestionInterface[]) =>
            curr.map((q: interfaces.QuestionInterface) => {
              if (q.id === question.id) {
                return {
                  ...q,
                  votes: q.asked ? q.votes - 1 : q.votes + 1,
                  asked: !q.asked
                };
              }

              return q;
            })) as any);
        }
      );
    },
    [updateMappedQuestions, userIsSet]
  );

  useEffect(() => {
    setOriginalQuestions(questions);
  }, [questions]);

  useEffect(() => {
    if (!client.id || !user.id || !userIsSet) return;
    QuestionServiceInstance?.getQuestions(client.id, user.id).then((questions: interfaces.QuestionInterface[]) => setQuestions(questions.sort((a, b) => +b.votes - +a.votes)));
  }, [userIsSet, isSignedIn]);

  const firstButtonClass = isMobile ? "mobile_first_ask_button" : "first_ask_button";

  const clientName = (
    client.id == '211' ? 'The City'       : // BridgePort
    client.id == '209' ? 'City'           : // White Salmon
    client.id == '223' ? 'Bay City'       : // Bay City
    client.id == '235' ? 'Cold Lake'      : // Cold Lake
    client.id == '241' ? 'Fountain Hills' : // Fountain Hills
    client.id == '261' ? 'the City'    : // Suisun City

    ( client?.firstName || 'Candidate' ).replace( / /g, '' )
  );

  const customHeaderText = getClientOptions(client)?.customText?.questionListHeader || null;
  const headerText = customHeaderText || `${t('Open Questions for')} ${clientName}`;

  return (
    <div className={cn(classes.QuestionsList, 'QuestionsList')}>
      <h1 className={cn(classes.title, 'title')} style={{ color: client?.openQuestionsAndAnswersColour }}>
        {headerText}
      </h1>

      <div className={cn(classes.questionsWrapper, 'questionsWrapper')}>
        {filteredQuestions
          .map((question, index) => (
            <QuestionsItem
              key={question.id}
              question={question}
              askButtonColor={client?.plusAskPillColour}
              onVoteClick={q => handleVoteClick(q)}
              classId={index === 0 ? firstButtonClass : ''}
            />
          ))}
      </div>
    </div>
  );
}
